import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import VirtualizedSelect from 'react-virtualized-select'
import { autocompleteRequest } from 'actions/wordlists';
import { getWordListOptions } from 'selectors/options';
import { isWordListAutoCompleteLoading } from 'selectors/loading';
import PureRenderComponent from 'components/core/PureRenderComponent';


class WordListAsyncSelect extends PureRenderComponent {

  handleInputChange = (value) => {
    value && this.props.autocompleteRequest(value);
  }

  render() {

    const {
      value,
      onChange,
      clearable,
      disabled,
      className,
      isLoading,
      style,
      multi,
      placeholder,
      wordlistOptions
    } = this.props;

    return (
      <VirtualizedSelect
        simpleValue={true}
        clearable={clearable}
        disabled={disabled}
        isLoading={isLoading}
        value={value}
        onChange={onChange}
        options={wordlistOptions}
        className={className}
        multi={multi}
        placeholder={placeholder}
        style={style}
        onInputChange={(value) => this.handleInputChange(value)}
        filterOption={(option, filterString) => {
          return (
            option.clientName.toLowerCase().indexOf(filterString) !== -1 ||
            option.clientFullNameEn.toLowerCase().indexOf(filterString) !== -1 ||
            option.clientFullNameJp.toLowerCase().indexOf(filterString) !== -1
          )
        }} />
    )
  }
}


const mapStateToProps = (state) => {
  return {
    isLoading: isWordListAutoCompleteLoading(state),
    wordlistOptions: getWordListOptions(state),
  }
}

const mapDispatchToProps = (disptach) => {
  return bindActionCreators({
    autocompleteRequest,
  }, disptach)
}

WordListAsyncSelect = connect(
  mapStateToProps,
  mapDispatchToProps
)(WordListAsyncSelect);


export default WordListAsyncSelect;
